var map = {
	"./fivedragons_en.png": "VPlW",
	"./fivedragons_esp.png": "p9We",
	"./fivedragons_th.png": "3cIv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Vd5P";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/fivedragons_.*\.png$
// module id = Vd5P
// module chunks = 1